import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useToast } from '../../components/ui/use-toast';
import { supabase } from '../../lib/supabase';
import { config } from '../../config/config';

export const StripeCallback: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { toast } = useToast();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const sessionId = params.get('session_id');

    const verifyStripePayment = async () => {
      try {
        // Vérifier le statut de la session Stripe
        const sessionResponse = await fetch(`https://api.stripe.com/v1/checkout/sessions/${sessionId}`, {
          headers: {
            'Authorization': `Bearer ${config.stripeSecretKey}`,
          }
        });

        if (!sessionResponse.ok) {
          throw new Error('Échec de la vérification du paiement Stripe');
        }

        const session = await sessionResponse.json();

        // Trouver la transaction correspondante
        const { data: transaction, error: fetchError } = await supabase
          .from('transactions')
          .select('*, contestants(contests(slug))')
          .eq('payment_reference', session.client_reference_id)
          .single();

        if (fetchError || !transaction) {
          console.error('Erreur lors de la récupération de la transaction:', fetchError);
          throw new Error('Transaction non trouvée');
        }

        if (session.payment_status === 'paid') {
          // Mettre à jour la transaction
          const updateData = {
            status: 'completed',
            payment_data: session,
            updated_at: new Date().toISOString(),
            phone_number: '237670000000' // Numéro par défaut pour Stripe
          };

          const { error: updateError } = await supabase
            .from('transactions')
            .update(updateData)
            .eq('payment_reference', session.client_reference_id)
            .select();

          if (updateError) {
            console.error('Erreur lors de la mise à jour de la transaction:', updateError);
            throw new Error(`Erreur de mise à jour: ${updateError.message}`);
          }

          toast({
            title: "Paiement réussi !",
            description: "Vos votes ont été comptabilisés.",
            variant: "default",
          });

          // Redirection vers la page du concours
          if (transaction.contestants?.contests?.slug) {
            navigate(`/c/${transaction.contestants.contests.slug}`);
          } else {
            navigate('/contests');
          }
        } else {
          throw new Error('Le paiement n\'a pas été complété');
        }
      } catch (error) {
        console.error('Erreur lors de la vérification du paiement:', error);
        toast({
          title: "Erreur de paiement",
          description: error instanceof Error ? error.message : "Une erreur est survenue lors du paiement",
          variant: "destructive",
        });
        navigate('/payment/error');
      }
    };

    if (sessionId) {
      verifyStripePayment();
    }
  }, [location.search, navigate, toast]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-gray-900 to-black text-white">
      <div className="text-center">
        <h2 className="text-2xl font-bold mb-4">Vérification du paiement en cours...</h2>
        <p className="text-gray-400">Veuillez patienter pendant que nous vérifions votre paiement.</p>
      </div>
    </div>
  );
};
